import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/components/AuthContext";
import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_exfoliating-bars/artifacts/xh2ysc0y_bd6a90e97_simplelogo.png";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/raffle");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/raffle';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-20" style={{ backgroundColor: '#0C0C0C' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Dermasand" className="h-16 mx-auto mb-4" />
          <h1 className="font-heading text-3xl font-light" style={{ color: '#F0EDE5' }}>Sign In</h1>
          <p className="font-body text-sm mt-2" style={{ color: '#9A9A9A' }}>Access your raffle entries & referral dashboard</p>
        </div>

        {/* Google Login */}
        <button
          onClick={handleGoogleLogin}
          className="w-full py-3 px-4 border flex items-center justify-center gap-3 font-body text-sm font-medium transition-colors hover:bg-[#1A1A1A]"
          style={{ borderColor: '#2A2A2A', color: '#F0EDE5' }}
          data-testid="google-login-btn"
        >
          <svg width="18" height="18" viewBox="0 0 18 18"><path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/><path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/><path d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z" fill="#FBBC05"/><path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/></svg>
          Continue with Google
        </button>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px" style={{ backgroundColor: '#2A2A2A' }} />
          <span className="font-body text-xs uppercase" style={{ color: '#666' }}>or</span>
          <div className="flex-1 h-px" style={{ backgroundColor: '#2A2A2A' }} />
        </div>

        {/* Email/Password Form */}
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            className="w-full px-4 py-3 text-sm font-body border outline-none focus:border-[#FF5A36] transition-colors"
            style={{ backgroundColor: '#141414', borderColor: '#2A2A2A', color: '#F0EDE5' }}
            data-testid="login-email-input"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="w-full px-4 py-3 text-sm font-body border outline-none focus:border-[#FF5A36] transition-colors"
            style={{ backgroundColor: '#141414', borderColor: '#2A2A2A', color: '#F0EDE5' }}
            data-testid="login-password-input"
          />
          {error && <p className="font-body text-xs" style={{ color: '#ef4444' }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 text-sm font-accent font-semibold tracking-wider uppercase text-white transition-all hover:brightness-110 disabled:opacity-50"
            style={{ backgroundColor: '#FF5A36' }}
            data-testid="login-submit-btn"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center mt-6 font-body text-sm" style={{ color: '#9A9A9A' }}>
          Don't have an account?{" "}
          <Link to="/register" className="font-semibold" style={{ color: '#FF5A36' }} data-testid="go-to-register">
            Sign Up
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
